import clsx from "clsx";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatErrorMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  return (
    <div className={clsx("w-full text-red-600")}>
      {showTime && <Time date={message.date} />} {message.message.content}
    </div>
  );
}
